import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

/**
 * Be careful using this hook. It only works because the number of
 * breakpoints in theme is static. It will break once you change the number of
 * breakpoints. See https://reactjs.org/docs/hooks-rules.html#only-call-hooks-at-the-top-level
 */
export function useWidth() {
    const theme = useTheme();
    const upXs = useMediaQuery(theme.breakpoints.up('xs'));
    const upSm = useMediaQuery(theme.breakpoints.up('sm'));
    const upMd = useMediaQuery(theme.breakpoints.up('md'));
    const upLg = useMediaQuery(theme.breakpoints.up('lg'));
    const upXl = useMediaQuery(theme.breakpoints.up('xl'));

    if (upXl) {
        return 'xl';
    } else if (upLg) {
        return 'lg';
    } else if (upMd) {
        return 'md';
    } else if (upSm) {
        return 'sm';
    } else if (upXs) {
        return 'xs';
    }

    return 'xs';
}